import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RolesPipe } from './pipes/roles/roles.pipe';
import { RoleDirective } from './directives/role/role.directive';
import { UserTypePipe } from './pipes/user-type/user-type.pipe';

@NgModule({
  declarations: [RolesPipe, RoleDirective, UserTypePipe],
  imports: [CommonModule],
  exports: [RolesPipe, RoleDirective, UserTypePipe]
})
export class RoleModule {}
